export default __webpack_public_path__ + "static/media/gf.15a7556a.svg";